import React from 'react';
import { useTranslation } from 'react-i18next';
import './LineInput.scss';
import TextThreeLinesIcon from '../../../images/text-lines-three-icon.png';
import TextTwoLinesIcon from '../../../images/text-lines-two-icon.png';
import ToggleButton from '../../ProducerComponents/ProducerControlPanel/Widgets/ToggleButton';
import useProject from '../../../hooks/useProject';
import Help from '../../Help/Help';

const LineInput = () => {
  const { t } = useTranslation();
  const { updateEncoder, updateStream, project } = useProject();

  const onChange = (value: string | number | boolean) => {
    if (project.stream?.sourceLanguageIsoCode === project.encoder?.languageIsoCode) {
      updateStream({
        aggregatorMaxLines: value,
      });
    } else {
      updateEncoder(project.encoder, {
        aggregatorMaxLines: value,
      });
    }
  };

  return (
    <div className="line-input">
      <div className="input-title">
        {t('producer.inputs.line.title')}
        <Help
          title="Number of Caption Lines"
          text="Select the preferred number of lines of captions to be displayed.<br/><br/><b>2 Lines</b>Standard choice for captioning.<br/><br/>Note, only use 2 lines if you are using YouTube for Closed Captions.  Other platforms do support three lines.<br/><br/><b>3 Lines</b>Can be used when numerous people are involved in a conversation to reflect the text.<br/><br/>This setting should be selected for language translation to allow all of the translated sentence to be displayed."
        />
      </div>
      <ToggleButton
        leftValue={2}
        leftImage={TextTwoLinesIcon}
        leftButtonClassName={`${
          project.encoder?.aggregatorMaxLines === 2 ? 'control-panel-button-selected-button' : null
        }`}
        rightValue={3}
        rightImage={TextThreeLinesIcon}
        rightButtonClassName={`${
          project.encoder?.aggregatorMaxLines === 3 ? 'control-panel-button-selected-button' : null
        }`}
        footerText={t('producer.inputs.line.footer')}
        isReadOnly={false}
        onSelection={onChange}
        leftAccessibilityName={t('producer.inputs.line.accessibility.two')}
        rightAccessibilityName={t('producer.inputs.line.accessibility.three')}
      />
    </div>
  );
};

export default React.memo(LineInput);
